import type FolderChangeDigestRequest from "owa-service/lib/contract/FolderChangeDigestRequest";
import type GetFolderChangeDigestRequest from "owa-service/lib/contract/GetFolderChangeDigestRequest";
import type GetFolderChangeDigestResponse from "owa-service/lib/contract/GetFolderChangeDigestResponse";
import type InboxViewType from "owa-service/lib/contract/InboxViewType";
import type TargetFolderId from "owa-service/lib/contract/TargetFolderId";
import getFolderChangeDigestOperation from "owa-service/lib/operation/getFolderChangeDigestOperation";
import type { MailboxInfo } from "owa-client-types";
import getMailboxRequestOptions from "owa-service/lib/getMailboxRequestOptions";
import { getApplicationSettings } from "owa-application-settings";
import { type RequestQueue, createRequestQueue } from "owa-service-utils";

// Max number of senders to return
const MAX_SENDERS_COUNT = 10;

let requestQueue: RequestQueue | undefined = undefined;

/**
 * Action to get focused inbox rollup data
 * @param folderId the target folder id
 * @param InboxViewType target view type
 * @param watermark indicates last visited timestamp for the view
 * @param isConversationView whether the folder is in conversation view
 * @return the GetFolderChangeDigestResponse
 */
export default function getFolderChangeDigestService(folderId: TargetFolderId, viewType: InboxViewType, watermark: string | undefined, isConversationView: boolean, mailboxInfo: MailboxInfo): Promise<GetFolderChangeDigestResponse> {
    const folderChangeDigest: FolderChangeDigestRequest = {
        FolderId: folderId,
        IsConversationView: isConversationView,
        ViewType: viewType,
        Watermark: watermark,
    };
    
    const getFolderChangeDigestRequest: GetFolderChangeDigestRequest = {
        Folders: [folderChangeDigest],
        MaxSendersCount: MAX_SENDERS_COUNT,
    };
    
    const { enabled, defaultMaxQueueSize } = getApplicationSettings("OwsApiRequestQueue");
    
    if (enabled) {
        if (!requestQueue) {
            requestQueue = createRequestQueue(defaultMaxQueueSize);
        }
        
        return requestQueue.add(() => getFolderChangeDigestOperation(getFolderChangeDigestRequest, getMailboxRequestOptions(mailboxInfo)).then(response => {
            return response;
        }));
    }
    
    return getFolderChangeDigestOperation(getFolderChangeDigestRequest, getMailboxRequestOptions(mailboxInfo)).then(response => {
        return response;
    });
}
